export function PagingHelper()
{
    var obj = {
        init: init,
        getPages: getPages,
        totalRecords: -1,
        totalPages: -1,
        recordsPerPage: -1
    };
    return obj;

    function init(totalRecords, recordsPerPage)
    {
        obj.totalRecords = totalRecords;
        obj.recordsPerPage = recordsPerPage;
        var pages = totalRecords/recordsPerPage;
        var floorPages = Math.floor(totalRecords/recordsPerPage)
        obj.totalPages = pages == floorPages ? pages : floorPages + 1;
    }

    function getPages(page)
    {
        if (obj.totalPages >= 1)
        {
            if (page > 0 && page <= obj.totalPages) {
                var n = page - 1;
                var startIndex = n * obj.recordsPerPage + 1;
                var endIndex = startIndex + obj.recordsPerPage - 1;
                if (endIndex > obj.totalRecords) endIndex = obj.totalRecords;
                // console.log("StartIndex: " + startIndex + " EndIndex: " + endIndex);
                var arr = [];
                while(startIndex < endIndex+1){
                  arr.push(startIndex++);
                };
                return arr;
            }
            else {
                console.log("Page out of bounds. Page:" + page + " Total Pages: " + obj.totalRecords);
            }
        }
        return [];
    }
}

// if (window.PatternLibrary)
// {
//     function PagingHelperUnitTest()
//     {
//         var pager = new PagingHelper();
//         pager.init(23,5);
//         assert_true("Total Records", pager.totalRecords == 23);
//         assert_true("Total Records", pager.recordsPerPage == 5);
//         assert_true("Total Pages", pager.totalPages == 5);

//         var pageFirst = pager.getPages(1);
//         assert_true("First Page - Page Length", pageFirst.length == 5);
//         assert_true("First Page - First Record", pageFirst[0] == 1);
//         assert_true("First Page - Last Record", pageFirst[4] == 5);

//         var pageLast = pager.getPages(pager.totalPages);
//         assert_true("Last Page - Page Length", pageLast.length == 3);
//         assert_true("Last Page - First Record", pageLast[0] == 21);
//         assert_true("Last Page - Last Record", pageLast[2] == 23);

//         var pager2 = new PagingHelper();
//         pager2.init(25,5);
//         assert_true("Total Records", pager2.totalRecords == 25);
//         assert_true("Total Records", pager.recordsPerPage == 5);
//         assert_true("Total Pages", pager.totalPages == 5);

//         pageFirst = pager2.getPages(1);
//         assert_true("First Page - Page Length", pageFirst.length == 5);
//         assert_true("First Page - First Record", pageFirst[0] == 1);
//         assert_true("First Page - Last Record", pageFirst[4] == 5);

//         pageLast = pager2.getPages(pager.totalPages);
//         assert_true("Last Page - Page Length", pageLast.length == 5);
//         assert_true("Last Page - First Record", pageLast[0] == 21);
//         assert_true("Last Page - Last Record", pageLast[4] == 25);

//         function assert_true(description, value)
//         {
//             if (value) {
//                 console.log("Test: " + description + " passed");
//             } else {
//                 console.log("Test: " + description + " FAILED");
//             }
//         }

//         function assert_false(description, value)
//         {
//             return assert_true(description, value == false);
//         }
//     };
//     PagingHelperUnitTest();
// }
